import React, { useState } from "react";

import {
  Select,
  InputLabel,
  MenuItem,
  Radio,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Autocomplete,
  TextField,
} from "@mui/material";
import ForwardIcon from "@mui/icons-material/Forward";
import DoNotDisturbOnOutlinedIcon from "@mui/icons-material/DoNotDisturbOnOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";

import SimpleTable from "views/Components/SimpleTable";
import { StyledAccountMappingView, classes } from "./styles";

const MSPIntegrationAccountMapping = () => {
  const CW_FAKE_ACCOUNTS = [
    {
      id: 3235,
      label: "Nexus Innovations",
    },
    {
      id: 8562,
      label: "Quantum Dynamics",
    },
    {
      id: 1363,
      label: "Evergreen Solutions",
    },
    {
      id: 4355,
      label: "Horizon Systems",
    },
  ];

  const MAPPING_METHODS = {
    companyId: {
      label:
        "Auto-map Blumira “Account Name” to ConnectWise Manage “Company ID”",
      value: "companyId",
    },
    companyName: {
      label:
        "Auto-map Blumira “Account Name” to ConnectWise Manage “Company name”",
      value: "companyName",
    },
    manual: {
      label: "Manually map",
      value: "maunual",
    },
  };

  const [catchall, setCatchall] = useState(CW_FAKE_ACCOUNTS[0]);

  const [mappingMethod, setMappingMethod] = useState(
    MAPPING_METHODS.companyId.value
  );

  const handleMappingMethodChange = (event) => {
    setMappingMethod(event.target.value);
  };

  const handleMSPCompanyChange = (event) => {
    console.warn(event.target.value);
  };

  const mappingTitle = () => {
    if (mappingMethod === MAPPING_METHODS.companyId.value) {
      return "ConnectWise Manage Company ID";
    } else if (mappingMethod === MAPPING_METHODS.companyName.value) {
      return "ConnectWise Manage Company Name";
    }

    return "ConnectWise Manage Company ID or Name";
  };

  const manageMSPSelect = (k) => {
    return (
      <Select
        id={`${k.blumiraAccount}-simple-select`}
        value={CW_FAKE_ACCOUNTS[0].id}
        onChange={handleMSPCompanyChange}
      >
        {CW_FAKE_ACCOUNTS.map((account) => (
          <MenuItem key={account.id} value={account.id}>
            {account.label}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const mappedChip = (
    <span className={`${classes.chip} ${classes.mappedChip}`}>
      <DoneOutlinedIcon /> Mapped
    </span>
  );

  const unMappedChip = (
    <span className={`${classes.chip} ${classes.unMappedChip}`}>
      <DoNotDisturbOnOutlinedIcon /> Not Mapped
    </span>
  );

  return (
    <StyledAccountMappingView>
      <div className={classes.catchallInput}>
        <InputLabel
          className={classes.catchallLabel}
          htmlFor="catchall-select-label"
        >
          Catchall
        </InputLabel>
        <Autocomplete
          id="catchall-select-label"
          sx={{ width: 300 }}
          options={CW_FAKE_ACCOUNTS}
          autoHighlight
          getOptionLabel={(option) => option.label}
          value={catchall}
          onChange={(_, newValue) => {
            setCatchall(newValue);
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </div>

      <div>
        <FormControl>
          <RadioGroup
            name="mapping-method"
            value={mappingMethod}
            onChange={handleMappingMethodChange}
          >
            <FormControlLabel
              value={MAPPING_METHODS.companyId.value}
              control={<Radio />}
              label={MAPPING_METHODS.companyId.label}
            />

            <FormControlLabel
              value={MAPPING_METHODS.companyName.value}
              control={<Radio />}
              label={MAPPING_METHODS.companyName.label}
            />

            <FormControlLabel
              value={MAPPING_METHODS.manual.value}
              control={<Radio />}
              label={MAPPING_METHODS.manual.label}
            />
          </RadioGroup>
        </FormControl>
      </div>

      <div>
        <SimpleTable
          isSearchHidden
          columns={[
            {
              field: "mapped",
              title: "Mapped",
              renderValue: (_, val) => (val.mapped ? mappedChip : unMappedChip),
            },
            { field: "blumiraAccount", title: "Blumira Account Name" },
            {
              field: "mapTo",
              title: "Map to",
              renderValue: () => <ForwardIcon />,
            },
            {
              field: "manage",
              title: mappingTitle(),
              renderValue: (_, k) => manageMSPSelect(k),
            },
          ]}
          data={[
            { mapped: false, blumiraAccount: "garb", id: 1 },
            { mapped: true, blumiraAccount: "agjl", id: 2 },
            { mapped: true, blumiraAccount: "asdfsdf", id: 3 },
          ]}
        ></SimpleTable>
      </div>
    </StyledAccountMappingView>
  );
};

export default MSPIntegrationAccountMapping;
